<template>
        <div
                class="flex h-screen bg-gray-50"
                :class="{ 'overflow-hidden': isSideMenuOpen }"
        >
                <WindmillSidebar />
                <WindmillMobileSidebar
                        :is-open="isSideMenuOpen"
                        @close="isSideMenuOpen = false"
                />
                <div class="flex flex-col flex-1 w-full md:ml-0">
                        <WindmillHeader @toggle-sidebar="isSideMenuOpen = !isSideMenuOpen" />
                        <main class="h-full overflow-y-auto">
                                <div class="w-full">
                                        <slot name="content" />
                                        <router-view v-slot="{ Component }">
                                                <transition
                                                        name="fade"
                                                        mode="out-in"
                                                >
                                                        <component :is="Component" />
                                                </transition>
                                        </router-view>
                                </div>
                        </main>
                </div>
        </div>
</template>

<script setup>
import { ref } from 'vue';
import WindmillSidebar from './partials/WindmillSidebar.vue';
import WindmillHeader from './partials/WindmillHeader.vue';
import WindmillMobileSidebar from './partials/WindmillMobileSidebar.vue';

const isSideMenuOpen = ref(false);
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
        transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
        opacity: 0;
}
</style>
